import { SidebarProvider } from './SidebarContext';
import { ThemeProvider } from './ThemeContext';
import { MapDataProvider } from '../../contexts/mapData.context';

export const providers = [
  SidebarProvider,
  ThemeProvider,
  MapDataProvider
]; 